module novaCmsDataSets {
  export interface IDelegation {
    delegationKey: string;
    delegationFn(): (e?: any) => any;
  }
  export class ProductDataSet {
    private _dataSource: kendo.data.DataSource;
    private _options: kendo.data.DataSourceOptions;
    private _productId: number;
    private _csrfToken: string;
    private _model: typeof kendo.data.Model;
    private _modelDelegations: IDelegation[];

    static string2Slug(str: string): string {
      str = str.replace(/^\s+|\s+$/g, '');
      str = str.toLowerCase();
      const from = 'ąćęłńśóźż·/_,:;';
      const to = 'acelnsozz------';
      const strLen: number = from.length;
      for (let i = 0; i < strLen; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }
      str = str.replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');

      return str;
    }

    get productId(): number {
      return this._productId;
    }

    get csrfToken(): string {
      return this._csrfToken;
    }

    get dataRow(): kendo.data.ObservableObject {

      if (this._dataSource.data.length > 0) {
        return this._dataSource.at(0) as kendo.data.ObservableObject;
      } else {
        return null;
      }
    }
    get dataSource(): kendo.data.DataSource {
      return this._dataSource;
    }
    constructor(csrfToken: string, productId?: number, modelDelegations?: IDelegation[]) {
      this._csrfToken = csrfToken;
      this._productId = productId;
      this._modelDelegations = modelDelegations ? modelDelegations : [];
      this.initModel();
      this.initOptions();
      this._dataSource = kendo.data.DataSource.create(this._options);
    }

    readData(): JQuery.Promise<any> {

      return this._dataSource.read();
    }

    saveData(): JQueryPromise<any> {
      return this._dataSource.sync();
    }

    deleteData() {
      if (this._dataSource.data.length > 0) {
        this._dataSource.remove(this._dataSource.at(0));
      }
    }

    getNewModel(): kendo.data.Model {
      return new this._model();
    }

    private initModel() {
      const modelDefinition = {
        id: 'ProductId',
        fields: {
          ProductId: {},
          DomainId: {
            type: 'number',
            defaultValue: null
          },
          ProductName: {
            type: 'string'
          },
          ProductName1: {
            type: 'string'
          },
          Ean: {
            type: 'string'
          },
          Code: {
            type: 'string'
          },
          ProductDescription: {
            type: 'string'
          },
          ProductSummary: {
            type: 'string'
          },
          RelatedPicture: {
            type: 'number'
          },
          ProductOptions: {
            type: 'string',
            defaultValue: '{"ProductGallery" : [],"ProductFunctions":{"FunctionsEnabled":false,"FunctionsImage":26,"FunctionsPoints":[]}}'
          },
          ProductUrl: {
            type: 'string'
          },
          Price1: {
            type: 'number'
          },
          Price2: {
            type: 'number'
          },
          PromoVideo: {
            type: 'string'
          },
          PromoVideo1: {
            type: 'string'
          },
          PublishingStatus: {
            type: 'number',
            defaultValue: 2
          },
          PublishingDate: {
            type: 'date'
          },
          UnpublishingDate: {
            type: 'date'
          },
          CreatorId: {
            type: 'number'
          },
          CreationDate: {
            type: 'date'
          },
          UpdaterId: {
            type: 'number'
          },
          UpdateDate: {
            type: 'date'
          },
          FeatureArray: {
            type: 'object',
            defaultValue: []
          },
          CategoriesArray: {
            type: 'object',
            defaultValue: []
          },
          AttributesArray: {
            type: 'object',
            defaultValue: []
          },
          TagsArray: {
            type: 'object',
            defaultValue: []
          }
        }
      };
      this._modelDelegations.forEach((value: IDelegation, ind) => {
        modelDefinition[value.delegationKey] = value.delegationFn;
      });
      this._model = kendo.data.Model.define(modelDefinition);
    }

    private initContentArray(value: any) {
      const returnArray: any[] = [];
      if (Array.isArray(value)) {
        value.forEach((el: any) => {
          returnArray.push(el.ContentId);
        });
      }

      return returnArray;
    }

    private initOptions() {
      this._options = {
        schema: {
          model: this._model,
          parse: (e) => {
            let tmpArr = [];
            if (!e.data) {
              tmpArr.push(e);
            } else {
              if (!Array.isArray(e.data)) {
                tmpArr.push(e.data);
              } else {
                tmpArr = e.data;
              }
              tmpArr.forEach((value: any) => {
                // Features
                value.FeatureArray = this.initContentArray(value.features);
                // Categories
                value.CategoriesArray = this.initContentArray(value.categories);
                // Attributes
                value.AttributesArray = this.initContentArray(value.attributes);
                // Tags
                value.TagsArray = this.initContentArray(value.tags);
              });
            }

            return tmpArr;
          }
        },
        transport: {
          read: {
            url: '/products/read' + ((this.productId) ? '/' + this.productId : ''),
            type: 'GET',
            dataType: 'json',
          },
          create: {
            url: '/products',
            type: 'POST',
            dataType: 'json',
            headers: { 'X-CSRF-TOKEN': this.csrfToken }
          },
          update: {
            url: '/products/edit',
            type: 'POST',
            dataType: 'json',
            headers: { 'X-CSRF-TOKEN': this.csrfToken }
          },
          destroy: {
            url: '/products/delete',
            type: 'POST',
            dataType: 'json',
            headers: { 'X-CSRF-TOKEN': this.csrfToken }
          },
          parameterMap: (data: any, operation) => {
            if (operation === 'update' || operation === 'create' || operation === 'destroy') { // tslint:disable-line
              for (const oneField in this._model.fields) {

                if (this._model.fields[oneField].hasOwnProperty('type')
                  && this._model.fields[oneField].type === 'date') {
                  if (data.hasOwnProperty(oneField) && data[oneField] !== null) {
                    data[oneField] = kendo.toString(data[oneField], 'yyyy-MM-dd HH:mm');
                  }
                }

              }

              return {
                product: data
              };
            }
          }
        }
      };
    }
  }
}
